import { Button, InfoPage, isLoggedIn } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";

function VerifyEmailError() {
  const navigation = useNavigation();
  const buttonText = isLoggedIn() ? "Back to Account" : "Back to Login";
  function navigateOnClick() {
    isLoggedIn() ? navigation.goToProfile() : navigation.goToSignIn();
  }

  return (
    <InfoPage
      variant="warning"
      title="Invalid link"
      description="This email confirmation link is expired or invalid. Please request a new one from your
              account page."
      primaryCTA={<Button onClick={navigateOnClick}>{buttonText}</Button>}
    />
  );
}

export default VerifyEmailError;
